import queryStringParser from 'query-string';
import config from '../../../config'

export const decodeQueryString = ({availableFilters, queryString, defaultQuery = {}, externalParams = {}}) => {
	const rawQuery = {
		...defaultQuery,
		...(queryString ? queryStringParser.parse(queryString, { arrayFormat: 'separator', arrayFormatSeparator: config.queryStringArraySeperator, skipNull: true, skipEmptyString: true }) : {}),
		...externalParams,
	}

	if(availableFilters) {
		return Object.keys(rawQuery).reduce((query, key) => {
			const filter = availableFilters[key];
			const rawValue = rawQuery[key];
			if(filter) {
				return {
					...query,
					[key]: (availableFilters[key].valueFormat === 'array' && typeof rawValue === 'string') ? [rawValue] : rawValue,
				}
			}
			else {
				return query;
			}
		}, {})
	}
	else {
		return rawQuery;
	}

}

export default decodeQueryString;